export default __webpack_public_path__ + "static/media/FXCalendar.2c4a5404.png";